<template>
    <div id="newsbackend">
        <el-container>
            <el-header style="color:white; padding-top:15px;font-size:25px;">TempleOfGood News Management
                <el-button type="info" round v-on:click="logout()">Log out</el-button>
                <span style="float:right; font-size:15px; margin-right:20px; margin-top:8px;">
                    {{ currentUser }} <span v-if="isAdminFlag">(Admin)</span>
                </span>
            </el-header>
            <el-container>
                <!-- left -->
                <el-aside style="width: 300px; min-height: 800px; background-color:#5262B3;">

                    <el-button icon="el-icon-plus" circle v-on:click="insertnewss" style="font-weight:1000;color:blue;width:60px;height:60px;position:absolute;top:65px;right:5px;z-index:1000;font-size: 35px;">
                    </el-button>

                    <el-menu
                    default-active="0"
                    @select="handleSelect"
                    class="el-menu-vertical-demo"
                    background-color="#5262B3"
                    text-color="#fff"
                    active-text-color="#ffd04b">

                        <el-submenu index="newsgroup">
                            <template slot="title" style="height:35px;line-height:35px;">
                                <i class="el-icon-news" style=" float:left; margin-top:19px; margin-left:0px;"></i>
                                <span style="float:left;">News List</span>
                            </template>

                            <el-menu-item index="news-0">
                                <span slot="title">0-All News</span>
                            </el-menu-item>

                            <el-menu-item :index="'news-' + type.id"
                                v-for="type in newsTypes" :key="type.id">
                                <span slot="title">{{type.id}}-{{type.name}}</span>
                            </el-menu-item>
                        </el-submenu>

                        <el-menu-item index="/listvideo" style="width:300px;">
                            <i class="el-icon-video-play" style=" float:left; margin-top:19px;"></i>
                            <span slot="title" style="float:left;">Video List</span>
                        </el-menu-item>
                    </el-menu>

                </el-aside>

                <!-- right -->
                <el-main>
                   <router-view  :key="key"></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import { NEWS_TYPES } from '@/constants/newsTypes';

export default {
    data () {
        return {
            newsTypes: NEWS_TYPES,
            currentUser: sessionStorage.getItem('loginin') || '',
            isAdminFlag: sessionStorage.getItem('isAdmin') === '1',
        }
    },
    computed: {
        key(){
            return this.$route.path;
        }
    },

    methods: {
        //注销
        logout(){
            sessionStorage.setItem('loginin','');
            sessionStorage.setItem('isAdmin','');
            this.$router.push({name: 'adminnews'});
        },

        insertnewss(){
            this.$router.push({ name: 'insertnews'});
        },

        // 菜单选中：news-N -> 新闻列表，/listvideo -> 视频列表
        handleSelect(key) {
            if (key === '/listvideo') {
                this.$router.push({ name: 'listvideo', params: { page: '1' }});
                return;
            }
            if (key.startsWith('news-')) {
                const type = key.slice('news-'.length);
                this.$router.push({ name: 'listnews', params: { type, page: '1' }});
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin oneline(){
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#newsbackend{
    width: 100%;

    .el-container{
        .el-header{
            background-color: #12278D;
            .el-button{
                float: right;
                margin-top:-5px;
            }
        }
        .el-container{
            .el-aside{

                .el-menu{
                    .el-submenu{
                        width: 300px;

                        .el-menu-item{
                            height:35px;
                            line-height:35px;

                            text-align: left;

                            @include oneline();

                            padding-right: 0;
                        }
                    }
                }
            }


        }
    }
}
</style>
